import { css } from 'lit';
const defaultStyle = css `
    :host,
    :host * {
        box-sizing: border-box;
    }

    :host {
        display: block;
    }
`;
export const appendDefaultStyle = (componentStyle) => [defaultStyle, componentStyle];
export default defaultStyle;
//# sourceMappingURL=index.js.map